/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* =========================================================================
   * Variant Image Filter
   *
   * Filters product gallery images based on alt-text convention:
   *   variant--<ColorValue>         → visible for that color only
   *   variant--<Color1>|<Color2>    → visible for specific multiple colors
   *   (no variant-- prefix)         → shared image, always visible after variant images
   *
   * Ordering: variant-specific images first, then shared/untagged images.
   * Images tagged for OTHER variants are hidden.
   *
   * Uses the existing data-variant attribute that Broadcast already sets
   * on <figure> elements inside product slides (see snippets/media.liquid).
   * No Liquid changes required — fully update-safe.
   * ========================================================================= */

  var HIDDEN_CLASS = 'variant-hidden';
  var VARIANT_PREFIX = 'variant--';

  // Inject CSS rule once
  var filterStyle = document.createElement('style');
  filterStyle.textContent = '.' + HIDDEN_CLASS + ' { display: none !important; }';
  document.head.appendChild(filterStyle);

  /**
   * Parse pipe-separated variant tags into a lowercase trimmed array.
   * e.g. "Rot|Grey Melange" → ["rot", "grey melange"]
   */
  function parseVariantTags(tagString) {
    if (!tagString) return [];
    return tagString.split('|').map(function(s) { return s.trim().toLowerCase(); });
  }

  /**
   * Check if an element has a cached variant tag matching the given color.
   */
  function matchesVariant(element, normalizedColor, normalizedModel) {
    var tags = element._variantTags;
    if (!tags || tags.length === 0) return false;
    if (tags.indexOf(normalizedColor) === -1) return false;

    var elModel = element._variantModel || '';
    if (elModel !== '') {
      return normalizedModel !== '' && elModel === normalizedModel;
    }
    return true;
  }

  /**
   * Propagate variant tags from the theme's existing data-variant attributes
   * (on <figure> elements) up to slide wrappers and across to thumbnails.
   * Caches parsed tag arrays on each element as _variantTags.
   */
  function setupVariantTags(container) {
    var productImages = container.querySelector('product-images');
    if (!productImages) return;

    // Read data-variant from <figure> inside each slide, strip prefix,
    // set data-variant-tag on the slide wrapper, cache parsed tags.
    productImages.querySelectorAll('[data-slide]').forEach(function(slide) {
      if (slide._variantOriginalOrder == null) {
        slide._variantOriginalOrder = Array.prototype.indexOf.call(slide.parentNode.children, slide);
      }
      if (slide._variantTags) return;
      var taggedEl = slide.querySelector('[data-variant]');
      if (!taggedEl) { slide._variantTags = []; slide._variantModel = ''; return; }
      var raw = taggedEl.getAttribute('data-variant');
      if (raw && raw.indexOf(VARIANT_PREFIX) === 0) {
        var tagValue = raw.substring(VARIANT_PREFIX.length);
        slide.setAttribute('data-variant-tag', tagValue);
        slide._variantTags = parseVariantTags(tagValue);
      } else {
        slide._variantTags = [];
      }
      var modelEl = slide.querySelector('[data-variant-model]');
      slide._variantModel = modelEl
        ? modelEl.getAttribute('data-variant-model').trim().toLowerCase()
        : '';
    });

    // Correlate thumbnails with slides via matching data-media-id.
    productImages.querySelectorAll('[data-thumb-item]').forEach(function(thumb) {
      if (thumb._variantOriginalOrder == null) {
        thumb._variantOriginalOrder = Array.prototype.indexOf.call(thumb.parentNode.children, thumb);
      }
      if (thumb._variantTags) return;
      var thumbLink = thumb.querySelector('[data-media-id]');
      if (!thumbLink) { thumb._variantTags = []; return; }
      var mediaId = thumbLink.getAttribute('data-media-id');
      var slide = productImages.querySelector('[data-slide][data-media-id="' + mediaId + '"]');
      if (slide && slide._variantTags && slide._variantTags.length > 0) {
        thumb.setAttribute('data-variant-tag', slide.getAttribute('data-variant-tag'));
        thumb._variantTags = slide._variantTags;
        thumb._variantModel = slide._variantModel || '';
      } else {
        thumb._variantTags = [];
        thumb._variantModel = '';
      }
    });
  }

  /**
   * Find option positions that Broadcast renders as color selectors.
   */
  function getColorOptionPositions(container) {
    var colorNamePattern = /\b(color|colour|couleur|farbe|farbe[n]?|farbton)\b/i;

    return Array.from(container.querySelectorAll('[data-option-position]')).reduce(function(positions, optionEl) {
      var label = optionEl.querySelector('.radio__legend__option-name, .radio__legend__label');
      var position = parseInt(optionEl.getAttribute('data-option-position'), 10);
      if (!label || isNaN(position)) return positions;
      if (colorNamePattern.test(label.textContent || '')) {
        positions.push(position - 1);
      }
      return positions;
    }, []);
  }

  /**
   * Detect which product option is the color option by matching the current
   * picker markup first, then falling back to the current variant's option values.
   * Returns the 0-based option index, or -1 if not found.
   */
  function detectColorOptionIndex(container, variant) {
    var productImages = container.querySelector('product-images');
    if (!productImages) return -1;

    var pickerPositions = getColorOptionPositions(container);
    if (pickerPositions.length === 1) {
      return pickerPositions[0];
    }

    // Collect all unique variant tag values from tagged slides
    var allTags = [];
    productImages.querySelectorAll('[data-slide][data-variant-tag]').forEach(function(slide) {
      (slide._variantTags || []).forEach(function(tag) {
        if (allTags.indexOf(tag) === -1) allTags.push(tag);
      });
    });

    if (allTags.length === 0) return -1;
    if (!variant || !variant.options) return -1;

    for (var i = 0; i < variant.options.length; i++) {
      if (allTags.indexOf(variant.options[i].trim().toLowerCase()) !== -1) {
        return i;
      }
    }

    return -1;
  }

  /**
   * Parse the selected variant JSON from a product-info container.
   */
  function parseSelectedVariant(container) {
    var script = container.querySelector('[data-selected-variant]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  /**
   * Restore the original DOM order captured before any filtering reordered media.
   */
  function restoreOriginalOrder(elements, parent) {
    if (!parent) return;

    elements
      .slice()
      .sort(function(a, b) {
        return (a._variantOriginalOrder || 0) - (b._variantOriginalOrder || 0);
      })
      .forEach(function(el) {
        parent.appendChild(el);
      });
  }

  /**
   * Classify elements into matching/shared/other and reorder them in the DOM.
   * Returns { matching, shared } arrays for further use.
   */
  function classifyAndReorder(elements, normalizedColor, normalizedModel, parent) {
    var matching = [], shared = [], other = [];

    elements.forEach(function(el) {
      if (matchesVariant(el, normalizedColor, normalizedModel)) {
        el.classList.remove(HIDDEN_CLASS);
        matching.push(el);
      } else if (!el.hasAttribute('data-variant-tag')) {
        el.classList.remove(HIDDEN_CLASS);
        shared.push(el);
      } else {
        el.classList.add(HIDDEN_CLASS);
        other.push(el);
      }
    });

    if (parent) {
      matching.concat(shared, other).forEach(function(el) {
        parent.appendChild(el);
      });
    }

    return { matching: matching, shared: shared };
  }

  /**
   * Main filter — shows/hides and reorders slides and thumbnails.
   *
   * Order: matching variant images → shared (untagged) images → hidden (other variants)
   */
  function filterMedia(container, colorValue, modelValue) {
    if (!container || !colorValue) return;

    var normalizedColor = colorValue.trim().toLowerCase();
    var normalizedModel = (modelValue || '').trim().toLowerCase();

    var cacheKey = normalizedColor + '||' + normalizedModel;
    if (container._lastAppliedColor === cacheKey) return;
    container._lastAppliedColor = cacheKey;

    var productImages = container.querySelector('product-images');
    if (!productImages) return;

    var mediaList = productImages.querySelector('[data-product-media-list]');
    var thumbsHolder = productImages.querySelector('[data-thumbs-slider]');
    var slides = Array.from(productImages.querySelectorAll('[data-slide]'));
    var thumbs = Array.from(productImages.querySelectorAll('[data-thumb-item]'));

    // Categorize and reorder slides
    var slideResult = classifyAndReorder(slides, normalizedColor, normalizedModel, mediaList);

    // Fallback: no tagged slides for this color → show all, undo reorder
    if (slideResult.matching.length === 0) {
      slides.forEach(function(slide) { slide.classList.remove(HIDDEN_CLASS); });
      thumbs.forEach(function(thumb) { thumb.classList.remove(HIDDEN_CLASS); });
      restoreOriginalOrder(slides, mediaList);
      restoreOriginalOrder(thumbs, thumbsHolder);
      productImages.productMediaItems = productImages.querySelectorAll('[data-slide]');
      patchArrowNavigation(productImages);
      return;
    }

    // Categorize and reorder thumbnails
    classifyAndReorder(thumbs, normalizedColor, normalizedModel, thumbsHolder);

    // If the active slide got hidden, switch to the first visible one
    var activeSlide = productImages.querySelector('.product__slide.media--active');
    var firstVisible = slideResult.matching[0] || slideResult.shared[0];
    if (activeSlide && activeSlide.classList.contains(HIDDEN_CLASS) && firstVisible) {
      var mediaId = firstVisible.getAttribute('data-media-id');
      if (mediaId && typeof productImages.setActiveMedia === 'function') {
        productImages.setActiveMedia(mediaId);
      }
    }

    // Refresh cached element references after DOM reorder
    productImages.productMediaItems = productImages.querySelectorAll('[data-slide]');

    // Patch arrow/swipe navigation to skip hidden slides
    patchArrowNavigation(productImages);
  }

  /**
   * Find the next visible slide in a given direction (1 = forward, -1 = backward).
   */
  function findVisibleNeighbor(productImages, direction) {
    var current = productImages.getCurrentMedia();
    if (!current) return null;

    var allSlides = Array.from(productImages.querySelectorAll('[data-slide]'));
    var currentIdx = allSlides.indexOf(current);

    for (var i = 1; i <= allSlides.length; i++) {
      var idx = (currentIdx + direction * i + allSlides.length) % allSlides.length;
      var candidate = allSlides[idx];
      if (!candidate.classList.contains(HIDDEN_CLASS) && candidate.hasAttribute('data-image-id')) {
        return candidate.getAttribute('data-media-id');
      }
    }
    return current.getAttribute('data-media-id');
  }

  /**
   * Override getNextMediaId / getPreviousMediaId on the product-images
   * instance so arrow keys and swipe gestures skip hidden slides.
   */
  function patchArrowNavigation(productImages) {
    if (!productImages || productImages._variantFilterPatched) return;

    var origGetNext = productImages.getNextMediaId;
    var origGetPrev = productImages.getPreviousMediaId;

    if (typeof origGetNext !== 'function' || typeof origGetPrev !== 'function') return;

    productImages.getNextMediaId = function() {
      return findVisibleNeighbor(this, 1) || origGetNext.call(this);
    };

    productImages.getPreviousMediaId = function() {
      return findVisibleNeighbor(this, -1) || origGetPrev.call(this);
    };

    productImages._variantFilterPatched = true;
  }

  /**
   * Return visible zoomable images in the current slide order.
   */
  function getVisibleZoomImages(zoomImagesEl) {
    if (!zoomImagesEl) return [];

    return Array.from(zoomImagesEl.querySelectorAll('[data-slide]'))
      .filter(function(slide) { return !slide.classList.contains(HIDDEN_CLASS); })
      .map(function(slide) { return slide.querySelector('[data-zoom-image]'); })
      .filter(Boolean);
  }

  /**
   * Build Photoswipe thumbs markup from the currently visible zoom images.
   */
  function buildVisibleZoomThumbsMarkup(zoomImagesEl) {
    return getVisibleZoomImages(zoomImagesEl).map(function(imageEl) {
      var thumbSource = imageEl.querySelector('img');
      if (!thumbSource) return '';

      var thumb = thumbSource.cloneNode(true);
      thumb.classList.add('pswp__thumb');
      thumb.removeAttribute('loading');
      thumb.removeAttribute('fetchpriority');

      return thumb.outerHTML;
    }).join('');
  }

  /**
   * Patch Broadcast's zoom gallery so Photoswipe only receives
   * the currently visible variant-filtered images.
   */
  function patchZoomGallery() {
    if (!window.customElements || !window.customElements.get) return;

    var ZoomImages = window.customElements.get('zoom-images');
    if (!ZoomImages || ZoomImages.prototype._variantZoomPatched) return;

    ZoomImages.prototype.createZoom = function(index) {
      var visibleImages = getVisibleZoomImages(this);
      if (!visibleImages.length || !window.theme || !window.theme.LoadPhotoswipe) return;

      var clickedImage = this.images && this.images[index] ? this.images[index] : null;
      var visibleIndex = clickedImage ? visibleImages.indexOf(clickedImage) : -1;
      if (visibleIndex < 0) visibleIndex = 0;

      var items = visibleImages.map(function(imageEl) {
        return {
          src: imageEl.getAttribute('data-image-src'),
          w: parseInt(imageEl.getAttribute('data-image-width'), 10),
          h: parseInt(imageEl.getAttribute('data-image-height'), 10),
          msrc: imageEl.getAttribute('data-image-src')
        };
      });

      var colorScheme = typeof this.getColorScheme === 'function' ? this.getColorScheme() : '';
      var isSingle = items.length === 1;
      var options = {
        history: false,
        focus: false,
        index: visibleIndex,
        mainClass: 'pswp-zoom-gallery' + (isSingle ? ' pswp-zoom-gallery--single' : '') + (colorScheme ? ' ' + colorScheme : ''),
        showHideOpacity: true,
        howAnimationDuration: 150,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: true,
        closeEl: true,
        closeElClasses: ['caption-close', 'title'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
        addCaptionHTMLFn: (function(instance) {
          return function(item, captionEl, isFake) {
            instance.zoomCaption(item, captionEl, isFake);
          };
        })(this),
        getThumbBoundsFn: function() {
          var imageEl = visibleImages[visibleIndex];
          var scrollTop = window.scrollY || document.documentElement.scrollTop;
          var bounds = imageEl.getBoundingClientRect();

          return {
            x: bounds.left,
            y: bounds.top + scrollTop,
            w: bounds.width
          };
        }
      };

      new window.theme.LoadPhotoswipe(items, options);

      if (this.thumbsContainer) {
        this.thumbsContainer.innerHTML = buildVisibleZoomThumbsMarkup(this);
      }
    };

    ZoomImages.prototype._variantZoomPatched = true;
  }

  /**
   * Initialize filtering for a single product-info container.
   */
  function initFilter(container) {
    if (container._variantFilterInitialized) return;

    setupVariantTags(container);

    var variant = parseSelectedVariant(container);
    if (!variant || !variant.options) return;

    var colorIndex = detectColorOptionIndex(container, variant);
    if (colorIndex < 0) return;

    container._variantColorIndex = colorIndex;

    var modelNamePattern = /\b(modell|model|typ|type)\b/i;
    container._variantModelIndex = -1;
    Array.from(container.querySelectorAll('[data-option-position]')).forEach(function(optionEl) {
      var label = optionEl.querySelector('.radio__legend__option-name, .radio__legend__label');
      var position = parseInt(optionEl.getAttribute('data-option-position'), 10);
      if (!label || isNaN(position)) return;
      if (modelNamePattern.test(label.textContent || '')) {
        container._variantModelIndex = position - 1;
      }
    });

    var currentColor = variant.options[colorIndex];
    var currentModel = container._variantModelIndex >= 0
      ? variant.options[container._variantModelIndex]
      : '';
    if (currentColor) {
      filterMedia(container, currentColor, currentModel);
    }

    container._variantFilterInitialized = true;
  }

  /**
   * Scan and initialize all product-info elements on the page.
   */
  function initAll() {
    document.querySelectorAll('product-info').forEach(initFilter);
  }

  // --- Lifecycle hooks ---

  // Run immediately (deferred script, DOM is parsed, theme.js has run)
  initAll();
  patchZoomGallery();

  // Remove CSS prefilter now that JS has taken over
  var prefilter = document.getElementById('variant-image-prefilter');
  if (prefilter) prefilter.remove();

  // Fallback for edge cases
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
  document.addEventListener('DOMContentLoaded', patchZoomGallery, { once: true });

  // Filter on variant change
  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
      var data = event.data;
      if (!data || !data.variant) return;

      var container = document.querySelector(
        'product-info[data-section="' + data.sectionId + '"]'
      );
      if (!container || container._variantColorIndex == null || container._variantColorIndex < 0) return;

      var colorValue = data.variant.options[container._variantColorIndex];
      var modelValue = container._variantModelIndex >= 0
        ? data.variant.options[container._variantModelIndex]
        : '';
      if (colorValue) {
        filterMedia(container, colorValue, modelValue);
      }
    });
  }

  // Handle product swap (e.g. sibling products reloading the section)
  document.addEventListener('theme:product-info:loaded', function(e) {
    var container = e.target;
    if (container && container.tagName && container.tagName.toLowerCase() === 'product-info') {
      container._variantFilterInitialized = false;
      container._variantColorIndex = null;
      container._lastAppliedColor = null;
      requestAnimationFrame(function() {
        initFilter(container);
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
